import { atom } from "recoil";
import { ProducerCode } from "../types";

export const empAddState = atom({
  key: "empAddState",
  default: false,
});
export const empEditState = atom({
  key: "empEditState",
  default: false,
});

export const rowForEditEmployees = atom({
  key: "rowForEditEmployees",
  default: {
    status: null,
    startdate: null,
    changeeffectivedate: null,
    rehireDate: null,
    terminationdate: null,
    onLeaveEffectiveDate: null,
    leavereturndate: null,
    forwardemailsto: null,
    reportstostatus: null,
    reportstotermdate: null,
    address: "",
    city: null,
    employeeState: null,
    stateCode: null,
    postalCode: null,
    zipcode: "",
    country: null,
    countryCode: null,
    latitude: null,
    longitude: null,
    geolocation: "",
    shippingLocation: "",
    county: null,
    emailDomainId: null,
    emailDomainName: null,
    isFranchise: false,
    employeeTypeId: null,
    statusId: null,
    reportsToEmployeeId: null,
    employmentTypeId: null,
    employmentTypeName: "",
    acquisitionName: "",
  },
});
export const employeeShowState = atom({
  key: "employeeShowState",
  default: false,
});

export const employeeFromOffice = atom({
  key: "employeeFromOffice",
  default: false,
});

export const employeeFromReports = atom({
  key: "employeeFromReports",
  default: false,
});

export const employeeViewData = atom({
  key: "employeeViewData",
  default: undefined,
});

export const selectedRowsStateEmployee = atom({
  key: "selectedRowsStateEmployee",
  default: [],
});
export const isSavingEmployees = atom({
  key: "isSavingEmployees",
  default: false,
});

export const employeeFromOfficeHierarchy = atom({
  key: "employeeFromOfficeHierarchy",
  default: false,
});

export const employeeFromProducerCode = atom({
  key: "employeeFromProducerCode",
  default: false,
});

export const employeeFromProdCodeRow = atom({
  key: "employeeFromProdCodeRow",
  default: false,
});

export const prodCodeViewRowData = atom({
  key: "prodCodeViewRowData",
  default: [],
});

export const empFilterValues = atom({
  key: "empFilterValues",
  default: {
    employeeId: "",
    Status: "",
    StatusId: null,
    employeeType: "",
    employeeTypeId: null,
    employmentType: "",
    employmentTypeId: null,
    title: "",
    businessOperation: "",
    location: [],
    terminationStatus: "",
    terminationReason: "",
    ConfieOrFranchise: "",
    search: "",
    acquisition: "",
    sort: "",
    isTressEmployee: false,
    brandId: [],
    counry: "",
    //multi filter
    selectedLocation: [],
    selectedBrandId: [],
  },
});

export const selectedEmpTab = atom({
  key: "selectedEmpTab",
  default: 0,
});

export const FranchiseOfficeDetailsData = atom({
  key: "FranchiseOfficeDetailsData",
  default: false,
});
export const OfficeListFromLink = atom({
  key: "OfficeListFromLink",
  default: "",
});

export const FromProdCodeToEmpData = atom({
  key: "FromProdCodeToEmpData",
  default: [],
});

export const FromRedirectionToEmpData = atom({
  key: "FromRedirectionToEmpData",
  default: [],
});

export const FromNotifEmp = atom({
  key: "FromNotifEmp",
  default: false,
});
export const editFromOffice = atom({
  key: "editFromOffice",
  default: false,
});

export const showKeyboard = atom({
  key: "showKeyboard",
  default: {
    firstName: false,
    middleName: false,
    lastName: false,
    preferredName: false,
    upn: false,
    suiteNumber: false,
    email: false,
  },
});

export const ehDataChart = atom({
  key: "ehDataChart",
  default: [],
});

export const mexicoOnly = atom({
  key: "mexicoOnly",
  default: false,
});

export const empProducerCodes = atom<ProducerCode[]>({
  key: "empProducerCodes",
  default: [],
});

export const prodCodeModal = atom({
  key: "prodCodeModal",
  default: false,
});

export const showDataModalState = atom({
  key: "showDataModalState",
  default: false,
});

export const employeeDataState = atom({
  key: "employeeDataState",
  default: { recordId: "", fullName: "" },
});
